import "./modules/base.js";
import "./modules/nav.js";
import "./modules/modal.js";
import "./modules/slider.js";
import "./modules/gallery.js";
import "./modules/intersection-observer.js";
import "./modules/infoimage.js";
import "./modules/swiper.js";
import "./modules/funnel.js";
import "./modules/gsap.js";

// import "./modules/history.js";
